export const GET_AMENDMENT_REVIEW_SUBJECT = 'GET_AMENDMENT_REVIEW_SUBJECT';
export const GET_AMENDMENT_CANDIDATE_PROFILE = 'GET_AMENDMENT_CANDIDATE_PROFILE';
export const GET_AMENDMENT_TRANSACTION_INFO = 'GET_AMENDMENT_TRANSACTION_INFO';
